export default function() {
  return {
    loading: false,
    maintenanceEnabled: false,
    maintenanceMessage: "",
    maintenanceScheduledStart: null
  };
}
